<template>
  <template v-for="item in routes" :key="item.path">
    <!--如果是叶子菜单-->
    <template v-if="!item.hidden && item.children">
      <div v-if="isLeafMenu(item)" @click="goToPage(item)">
        <el-menu-item :index="item.path" :class="{ 'submenu-title-noDropdown': !isNest }">
          <el-icon :size="16">
            <component :is="item.meta.icon"></component>
          </el-icon>
          <!-- <i class="mgr10 iconfont" :class="item.meta.icon"></i> -->
          <span v-if="item.meta && item.meta.title">{{ item.meta.title }}</span>
        </el-menu-item>
      </div>
      <!--如果是叶子菜单-->
      <template v-else-if="isDesktopGroup(item)" v-for="topItem in item.children" :key="topItem.path">
        <el-menu-item :index="topItem.path" :class="{ 'submenu-title-noDropdown': !isNest }" @click="goToPage(topItem)">
          <el-icon :size="20">
            <component :is="topItem.meta.icon"></component>
          </el-icon>
          <template #title>
            <span v-if="topItem.meta && topItem.meta.title">{{ topItem.meta.title }}</span>
          </template>
        </el-menu-item>
      </template>
      <!--创建子菜单组-->
      <el-sub-menu v-else :index="item.name || item.path" :key="item.name">
        <template #title>
          <el-icon :size="20">
            <component :is="item.meta.icon"></component>
          </el-icon>
          <span v-if="item.meta && item.meta.title">{{ item.meta.title }}</span>
        </template>
        <template v-for="child in item.children" :key="child.path">
          <sidebar-item :is-nest="true" class="nest-menu" v-if="child.children && child.children.length > 0"
            :routes="[child]" :key="child.path"> </sidebar-item>
          <!-- <router-link v-else :to="item.path+'/'+child.path" :key="child.name"> -->
          <div v-else @click="goToPage(child, item)">
            <el-menu-item :index="item.path + '/' + child.path">
              <el-icon :size="16">
                <component :is="child.meta.icon"></component>
              </el-icon>
              <span v-if="child.meta && child.meta.title">{{ child.meta.title }}</span>
            </el-menu-item>
          </div>
        </template>
      </el-sub-menu>
    </template>
  </template>
</template>

<script>
import { Tools, MagicStick, DataLine, Finished, More, HomeFilled, Plus, ArrowRightBold, Connection, Notebook } from '@element-plus/icons-vue'

export default {
  name: 'sidebarItem',
  components: {
    Tools,
    MagicStick,
    DataLine,
    Finished,
    More,
    HomeFilled,
    ArrowRightBold,
    Plus,
    Connection,
    Notebook,
  },
  props: {
    routes: {
      type: Array,
    },
    isNest: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    isDesktopGroup(item) {
      if (item.path == '/desktop') {
        return true
      }
      return false
    },
    isLeafMenu(item) {
      if (item.children && item.children.length > 0) return false
      return true
    },
    goToPage(route, item) {
      route.meta['keepAlive'] = false
      setTimeout(() => {
        if (item) {
          this.$router.push({ path: item.path + '/' + route.path })
        } else {
          this.$router.push({ path: route.path })
        }
      }, 10)
    },
  },
}
</script>

<style>
a {
  text-decoration: none !important;
}

.icon-font {
  font-size: 18px;
  font-weight: 400;
  margin-right: 5px;
}

.icon-fontCare {
  font-size: 18px;
  font-weight: 400;
  margin-right: 5px;
  font-weight: bold;
  color: darkorange;
}

.mgr10 {
  margin-right: 10px;
}

.mgr5 {
  margin-right: 5px;
}
</style>
<style lang="scss" scoped>
// :deep(.el-submenu__icon-arrow) {
//   position: absolute;
//   top: 53%;
//   right: 40px;
//   margin-top: -7px;
//   -webkit-transition: -webkit-transform 0.1s;
//   transition: -webkit-transform 0.1s;
//   transition: transform 0.1s;
//   transition: transform 0.1s, -webkit-transform 0.1s;
//   transition: transform 0.1s, -webkit-transform 0.1s;
//   font-size: 12px;v
// .el-menu-item{
//   height: 40px !important;
// }
// ::v-deep .el-menu-item {
//   height: 40px !important;
// }

// ::v-deep .el-sub-menu__title {
//   height: 40px !important;
// }

// ::v-deep .submenu-title-noDropdown {
//   height: 40px !important;
// }
</style>
